import { Component, EventEmitter, Output } from '@angular/core';

@Component({
    selector: 'app-welcome-step',
    templateUrl: './welcome-step.component.html',
    styleUrls: ['./welcome-step.component.scss'],
    standalone: false
})
export class WelcomeStepComponent {
  @Output() next = new EventEmitter<void>();
  @Output() back = new EventEmitter<void>();

  onNext(): void {
    this.next.emit();
  }

  onBack(): void {
    this.back.emit();
  }

  openLink(url: string): void {
    window.open(url, '_blank');
  }
}
